import React from 'react'
import { Use_reduce_state } from './Store'

function Search() {
    const {product:{searchKey}, dis} = Use_reduce_state();

  return (
    <div>
    <nav className="navbar navbar-expand-lg bg-light">
    <div className="container-fluid">
        <form className="d-flex" role="search">
      <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"
        onChange={(e) =>{
            dis({
                type:"SEARCH",
                payload:e.target.value
            })
        }}
      />
    </form>
    </div>
    </nav>
    </div>
  )
}

export default Search